export const DR_UPDATE_LIST = 'DR_UPDATE_LIST'
export const DR_UPDATE_LIST_METHOD = 'DR_UPDATE_LIST_METHOD'
export const DR_UPDATE_FORM_ERROR = 'DR_UPDATE_FORM_ERROR'
export const DR_UPDATE_FORM = 'DR_UPDATE_FORM'
export const DR_UPDATE_FORM_FIELD = 'DR_UPDATE_FORM_FIELD'
export const DR_UPDATE_PREVIEW = 'DR_UPDATE_PREVIEW'
export const DR_UPDATE_DIALOG = 'DR_UPDATE_DIALOG'

export const updateDevelopmentalRubricsList = (curriculumId, { data, count, ids }) => ({
  type: DR_UPDATE_LIST,
  payload: { curriculumId, data, count, ids }
})
export const updateDevelopmentalRubricsListMethod = (curriculumId, method, data) => ({
  type: DR_UPDATE_LIST_METHOD,
  payload: { curriculumId, method, data }
})
export const updateDevelopmentalRubricFormError = (error = null) => ({
  type: DR_UPDATE_FORM_ERROR,
  payload: error
})
export const updateDevelopmentalRubricForm = (data) => ({
  type: DR_UPDATE_FORM,
  payload: data
})
export const updateDevelopmentalRubricFormField = (field, value) => ({
  type: DR_UPDATE_FORM_FIELD,
  payload: { field, value }
})
export const updateDevelopmentalRubricPreview = (preview = null, type = 'lcs') => ({
  type: DR_UPDATE_PREVIEW,
  payload: { preview, type }
})
export const updateDevelopmentalRubricDialog = (open = false, type, form) => ({
  type: DR_UPDATE_DIALOG,
  payload: { open, type, form }
})
